import DetectInApp from "detect-inapp"
import isStandalone from "@/lib/is-platform/is-standalone"
import isAppStore from "@/lib/is-platform/is-app-store"
import isBuilderContext from "@/lib/is-platform/is-builder-context"
import isPreviewContext from "@/lib/is-platform/is-preview-context"
import isSupportedDevice from "@/lib/is-platform/is-supported-device"
import isIos from "@/lib/is-platform/is-ios"
import isAndroid from "@/lib/is-platform/is-android"

const detectInApp = new DetectInApp(
  navigator.userAgent || navigator.vendor || window.opera
)

const isSafari = () =>
  /^((?!chrome|crios|edgios|android).)*safari/i.test(navigator.userAgent) &&
  detectInApp.browser === "safari"

const isInApp = () => {
  // detect-inapp's isInApp incorrectly matches Chrome on Android
  // https://github.com/f2etw/detect-inapp/issues/52
  const ua = navigator.userAgent || navigator.vendor || window.opera

  const rules = [
    "WebView",
    "Instagram",
    "(iPhone|iPod|iPad)(?!.*Safari/)",
    "Android.*wv\\)",
    "FB_\\w|FB\\w",
    "Snapchat",
    "musical_ly",
    "BytedanceWebview",
    "MicroMessenger", // WeChat
    "TwitterAndroid"
  ]

  const regex = new RegExp(rules.map(r => `(${r})`).join("|"), "ig")

  return !!ua && ua.match(regex) !== null && !isAppStore()
}

const isCypress = () => !!window.Cypress

const isIpad = () =>
  /Macintosh/i.test(navigator.userAgent) &&
  navigator.maxTouchPoints &&
  navigator.maxTouchPoints > 1

const isNativePush = isAppStore()

const isMobile = () => window.matchMedia("(max-width: 768px)").matches

const isIosSafari = () => isIos() && isSafari()

const isIosSafariWithPageMenu = () =>
  isIosSafari() &&
  Number(navigator.userAgent.match(/Version\/(\d+)/)?.[1]) >= 27

const isEdge = () => /EdgiOS|EdgA/i.test(navigator.userAgent)
const isIosEdge = () => isIos() && isEdge()

const isMetaBrowser = () =>
  isInApp() &&
  ["facebook", "instagram", "messenger"].includes(detectInApp.browser)

// Touch-primary device (phone/tablet with an on-screen keyboard) rather than a
// narrow viewport. Avoids treating a desktop in a small/iframed window as mobile.
const isTouchDevice = () => window.matchMedia("(pointer: coarse)").matches

export {
  isStandalone,
  isAppStore,
  isBuilderContext,
  isPreviewContext,
  isSafari,
  isIos,
  isAndroid,
  isIosSafari,
  isIosSafariWithPageMenu,
  isIosEdge,
  isEdge,
  isInApp,
  isMetaBrowser,
  isIpad,
  isCypress,
  isNativePush,
  isSupportedDevice,
  isMobile,
  isTouchDevice
}
